import React from 'react';
import ReactDOM from 'react-dom';

const ColorPicker = React.createClass({
  displayName: 'ColorPicker',

  getDefaultProps: function () {
    return {
      disabled: false,
      name: '',
      value: ''
    };
  },

  propTypes: {
    name: React.PropTypes.string
  },

  onChange: function (hex) {
    let colorInt = this.hexToInt(hex);
    this.props.onChange(this.props.name, colorInt);
  },

  intToHex: function (color) {
    return '#' + color.toString(16)
  },

  hexToInt: function (hex) {
    return parseInt(hex.replace('#', ''), 16);
  },

  componentDidMount: function () {
    let defaultValue = this.intToHex(this.props.value);

    $(ReactDOM.findDOMNode(this)).minicolors({
      defaultValue: defaultValue,
      format: 'hex',
      change: this.onChange,
      theme: 'bootstrap'
    });
  },

  render: function () {
    return (<input name={this.props.name} style={{width: '100%'}} disabled={this.props.disabled}/>);
  }
});

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/js/Component/ColorPicker.jsx